var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-4"},[_c('span',[_vm._v("There are currently no "+_vm._s(_vm.districtType)+" district proposals")])])
}
var staticRenderFns = []

export { render, staticRenderFns }